import { Component, type ReactNode } from "react";
import { ErrorPage } from "../pages/ErrorPage";

interface Props {
  children: ReactNode;
}

interface State {
  crashed: boolean;
}

/**
 * Last-resort UI for a render failure. The message shown is the generic
 * 500 page — the exception itself is not rendered.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { crashed: false };

  static getDerivedStateFromError(): State {
    return { crashed: true };
  }

  componentDidCatch(): void {
    // The API records server errors. Client render failures stay on this page.
  }

  render(): ReactNode {
    if (this.state.crashed) {
      return <ErrorPage code={500} />;
    }
    return this.props.children;
  }
}
